var _defs, _rect, _rect2, _path, _path2, _path3, _path4, _circle, _rect3, _rect4, _path5, _path6, _polygon, _path7, _path8, _path9, _path10, _path11, _path12, _line, _path13, _rect5, _rect6, _text, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgObj25(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1548.6 264.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#aae2c2;}.cls-2{fill:#50bd86;}.cls-3{fill:#434341;}.cls-4,.cls-6{fill:#fff;}.cls-5{fill:#ffdc00;}.cls-6{font-size:45px;font-family:CloserText-Black, Closer Text;font-weight:800;letter-spacing:0.05em;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 408.66,
    y: 169.49,
    width: 150.31,
    height: 50.95,
    rx: 10.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 439.23,
    y: 141.47,
    width: 89.17,
    height: 89.17,
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M525.67,232H442a4.11,4.11,0,0,1-4.1-4.1V144.2a4.11,4.11,0,0,1,4.1-4.1h83.71a4.1,4.1,0,0,1,4.09,4.1v83.7A4.1,4.1,0,0,1,525.67,232ZM442,142.83a1.36,1.36,0,0,0-1.36,1.37v83.7a1.36,1.36,0,0,0,1.36,1.37h83.71A1.36,1.36,0,0,0,527,227.9V144.2a1.36,1.36,0,0,0-1.36-1.37Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M528.4,148.23V117.14A15.16,15.16,0,0,0,513.24,102H454.39a15.16,15.16,0,0,0-15.16,15.16v27.52a54.76,54.76,0,0,0,89.17,3.57Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M485.09,170.86a56,56,0,0,1-47-25.45l-.23-.35V117.14a16.55,16.55,0,0,1,16.53-16.53h58.85a16.54,16.54,0,0,1,16.52,16.53V148.7l-.28.37A55.82,55.82,0,0,1,485.09,170.86ZM440.6,144.25A53.39,53.39,0,0,0,527,147.76V117.14a13.81,13.81,0,0,0-13.79-13.8H454.39a13.81,13.81,0,0,0-13.79,13.8Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M506.88,110.4H460.75v-8.06c0-14,10-25.34,22.3-25.34h1.53c12.3,0,22.3,11.37,22.3,25.34Zm-42-4.1h37.94v-4c0-11.71-8.16-21.24-18.2-21.24h-1.53c-10,0-18.21,9.53-18.21,21.24Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 483.81,
    cy: 149.11,
    r: 7.64
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 448.15,
    y: 186.05,
    width: 30.57,
    height: 30.57,
    rx: 1.6
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 488.91,
    y: 186.05,
    width: 30.57,
    height: 30.57,
    rx: 1.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M745.51,247.17a92.63,92.63,0,1,0-92.68-92.62A92.65,92.65,0,0,0,745.51,247.17Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M745.51,249A94.46,94.46,0,1,1,840,154.55,94.59,94.59,0,0,1,745.51,249Zm0-185.25a90.8,90.8,0,1,0,90.85,90.8A90.92,90.92,0,0,0,745.51,63.75Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "847.63 78.74 824.14 77.17 822.22 53.33 855.96 19.58 857.71 43.25 881.37 45 847.63 78.74"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M848.34,80.62l-25.89-1.74-2.12-26.25,37.15-37.16,1.94,26.07,26.07,1.93Zm-22.5-5.17,21.09,1.41,30.33-30.33L856,45,854.43,23.7,824.1,54Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M745.51,227.86a73.32,73.32,0,1,0-73.36-73.31A73.33,73.33,0,0,0,745.51,227.86Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M745.51,205.64a51.1,51.1,0,1,0-51.13-51.09A51.11,51.11,0,0,0,745.51,205.64Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M745.51,207.47a52.93,52.93,0,1,1,53-52.92A53,53,0,0,1,745.51,207.47Zm0-102.2a49.28,49.28,0,1,0,49.3,49.28A49.34,49.34,0,0,0,745.51,105.27Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M745.51,180.16a25.61,25.61,0,1,0-25.63-25.61A25.62,25.62,0,0,0,745.51,180.16Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M745.51,182A27.44,27.44,0,1,1,773,154.55,27.47,27.47,0,0,1,745.51,182Zm0-51.22a23.79,23.79,0,1,0,23.8,23.79A23.82,23.82,0,0,0,745.51,130.76Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 746.1,
    y1: 154.02,
    x2: 856.98,
    y2: 43.14
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M746.1,155.84a1.8,1.8,0,0,1-1.29-.53,1.82,1.82,0,0,1,0-2.59L855.69,41.85a1.82,1.82,0,0,1,2.58,2.58L747.39,155.31A1.78,1.78,0,0,1,746.1,155.84Z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 877.35,
    y: 154.89,
    width: 257,
    height: 34,
    rx: 17
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 886.35,
    y: 160.01,
    width: 85,
    height: 23.75,
    rx: 11.5
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(1158.64 187.84)"
  }, "25%")), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M303.12,73.88l-19.74,4a.76.76,0,0,0-.65.65l-3.18,19.67a.78.78,0,0,1-1.53,0l-4.17-19.48a.78.78,0,0,0-.63-.6l-18.76-4.26a.78.78,0,0,1-.05-1.53l18.49-3.56a.75.75,0,0,0,.57-.57l4.58-18.71a.79.79,0,0,1,1.53,0L283.28,68a.8.8,0,0,0,.58.61l19.33,3.78A.78.78,0,0,1,303.12,73.88Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1362.54,73l-27.72,5.66a1.08,1.08,0,0,0-.91.91l-4.47,27.63a1.09,1.09,0,0,1-2.15.05l-5.85-27.35a1.08,1.08,0,0,0-.88-.85l-26.34-6a1.09,1.09,0,0,1-.07-2.14l26-5a1.11,1.11,0,0,0,.8-.81l6.43-26.26a1.09,1.09,0,0,1,2.13,0l5.21,25.79a1.09,1.09,0,0,0,.81.85l27.13,5.32A1.09,1.09,0,0,1,1362.54,73Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1019.78,227.31l-14.47,2.95a.57.57,0,0,0-.47.48l-2.33,14.41a.57.57,0,0,1-1.12,0l-3.06-14.27a.57.57,0,0,0-.46-.44l-13.74-3.12a.57.57,0,0,1,0-1.12l13.55-2.61a.56.56,0,0,0,.42-.42l3.35-13.7a.57.57,0,0,1,1.12,0l2.71,13.46a.58.58,0,0,0,.43.44l14.15,2.77A.57.57,0,0,1,1019.78,227.31Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M127.78,186.31l-14.47,2.95a.57.57,0,0,0-.47.48l-2.33,14.41a.57.57,0,0,1-1.12,0l-3.06-14.27a.57.57,0,0,0-.46-.44l-13.74-3.12a.57.57,0,0,1,0-1.12l13.55-2.61a.56.56,0,0,0,.42-.42l3.35-13.7a.57.57,0,0,1,1.12,0L113.24,182a.58.58,0,0,0,.43.44l14.15,2.77A.57.57,0,0,1,127.78,186.31Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1455.78,127.31l-14.47,2.95a.57.57,0,0,0-.47.48l-2.33,14.41a.57.57,0,0,1-1.12,0l-3.06-14.27a.57.57,0,0,0-.46-.44l-13.74-3.12a.57.57,0,0,1,0-1.12l13.55-2.61a.56.56,0,0,0,.42-.42l3.35-13.7a.57.57,0,0,1,1.12,0l2.71,13.46a.58.58,0,0,0,.43.44l14.15,2.77A.57.57,0,0,1,1455.78,127.31Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1132.11,35.89l-17.17,3.51a.68.68,0,0,0-.57.56l-2.76,17.12a.68.68,0,0,1-1.34,0l-3.62-17a.68.68,0,0,0-.55-.52l-16.32-3.71a.67.67,0,0,1,0-1.32l16.09-3.1a.67.67,0,0,0,.49-.5l4-16.27a.68.68,0,0,1,1.32,0l3.22,16a.69.69,0,0,0,.51.52l16.81,3.29A.68.68,0,0,1,1132.11,35.89Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M626.18,66.26,607.86,70a.73.73,0,0,0-.6.6l-3,18.26a.72.72,0,0,1-1.42,0L599,70.82a.71.71,0,0,0-.58-.56l-17.4-4a.72.72,0,0,1,0-1.41l17.16-3.3a.75.75,0,0,0,.53-.53l4.25-17.36a.72.72,0,0,1,1.41,0l3.44,17a.71.71,0,0,0,.53.56l17.93,3.52A.72.72,0,0,1,626.18,66.26Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M881.59,110.69a13.31,13.31,0,0,1,18.23,0,13.62,13.62,0,0,1,0,18.41,13.31,13.31,0,0,1-18.23,0,13.65,13.65,0,0,1,0-18.41Zm5.3,13.53a5.13,5.13,0,0,0,7.61,0,6.95,6.95,0,0,0,0-8.65,5.11,5.11,0,0,0-7.61,0,7,7,0,0,0,0,8.65Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M919.25,107.64a10.59,10.59,0,0,1,6.68,2,6.19,6.19,0,0,1,2.56,5.13,6.71,6.71,0,0,1-2,4.76,6.6,6.6,0,0,1,2.66,5.35,6.38,6.38,0,0,1-2.61,5.26,10.79,10.79,0,0,1-6.81,2H907.31v-24.5Zm-4.55,6.2v3h4.48a2.13,2.13,0,0,0,1.4-.43,1.35,1.35,0,0,0,.52-1.07,1.29,1.29,0,0,0-.52-1,2.18,2.18,0,0,0-1.4-.42Zm0,8.78v3.29h5a2.28,2.28,0,0,0,1.49-.45,1.52,1.52,0,0,0,.54-1.23,1.43,1.43,0,0,0-.56-1.13,2.2,2.2,0,0,0-1.47-.48Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M930.9,125.35a6.83,6.83,0,0,0,2.84.56q3.46,0,3.46-3.36V107.64h7.42v16.07a8.47,8.47,0,0,1-2.69,6.51,10,10,0,0,1-7,2.49,7,7,0,0,1-4-.81Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M949.21,107.64h18.9v6.2H956.59v2.9h9.91v6h-9.91v3.15h11.87v6.23H949.21Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M986.1,113.84v18.3h-7.39v-18.3h-7.38v-6.2h22.15v6.2Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M997,107.64h7.38v24.5H997Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1007.59,107.64h8l5.39,15,5.28-15h8l-10,24.5h-6.62Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1038.88,110.69a13.31,13.31,0,0,1,18.23,0,13.65,13.65,0,0,1,0,18.41,13.31,13.31,0,0,1-18.23,0,13.65,13.65,0,0,1,0-18.41Zm5.3,13.53a5.13,5.13,0,0,0,7.61,0,6.95,6.95,0,0,0,0-8.65,5.11,5.11,0,0,0-7.61,0,7,7,0,0,0,0,8.65Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObj25);
export default __webpack_public_path__ + "static/media/Obj_25.3b39d8e6081982a7159fa01ed8b0adcf.svg";
export { ForwardRef as ReactComponent };